import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoPage } from 'lo-design-system';
import { UserHeaderComponent } from '../user-header/user-header.component';

@Component({
	standalone: true,
	selector: 'app-settings-con',
	template: `
		<lo-page layout="centered">
			<app-user-header loPageHead></app-user-header>
			<router-outlet></router-outlet>
		</lo-page>
	`,
	imports: [LoPage, UserHeaderComponent, RouterOutlet]
})
export class SettingsConComponent {}
